<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Liquidación</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <router-link
            v-if="$can('store', 'documents')"
            :to="{ name: 'DocumentCreate' }"
            class="btn base-button btn-neutral btn-sm"
          >
            Nuevo
          </router-link>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col">
          <documents-table v-if="isLoaded" :entity="entity" :title="title" :type="type"> </documents-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import DocumentsTable from '@/views/Documents/List/DocumentsTable';

export default {
  name: 'DocumentsSettlement',
  components: {
    RouteBreadCrumb,
    DocumentsTable,
  },

  data() {
    return {
      title: '',
      type: '',
      entity: '',
      isLoaded: false,
    };
  },

  mounted() {
    this.title = this.$route.meta.subtitle;
    this.type = this.$route.meta.type;
    this.entity = this.$route.meta.entity;
    this.isLoaded = true;
  },
};
</script>
